import React, { useState } from "react";
import { View, Text, TextInput, TouchableOpacity, StyleSheet } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { useApi } from "../context/ApiContext";

const AppleDeveloperConfig = ({ team, onUpdate }) => {
	const { api } = useApi();
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [showPassword, setShowPassword] = useState(false);
	const [config, setConfig] = useState({
		appleId: "",
		teamId: "",
		apiKey: "",
		issuerId: "",
		keyId: "",
		bundleId: "",
	});

	const handleConfigChange = (field, value) => {
		setConfig((prev) => ({
			...prev,
			[field]: value,
		}));
	};

	const handleSave = async () => {
		try {
			setLoading(true);
			setError(null);

			const response = await api("/team", {
				method: "PUT",
				body: {
					teamId: team.id,
					action: "AppleAppStore",
					appStoreInfo: config,
				},
			});

			onUpdate?.(response);
		} catch (err) {
			setError(err.message);
		} finally {
			setLoading(false);
		}
	};

	return (
		<View style={styles.container}>
			<Text style={styles.title}>Apple Developer Configuration</Text>

			{error && (
				<View style={styles.errorContainer}>
					<Text style={styles.errorText}>{error}</Text>
				</View>
			)}

			<View style={styles.formGroup}>
				<Text style={styles.label}>
					Apple ID <Text style={styles.required}>*</Text>
				</Text>
				<TextInput style={styles.input} value={config.appleId} onChangeText={(text) => handleConfigChange("appleId", text)} placeholder="Enter your Apple ID" placeholderTextColor="#666" />
			</View>

			<View style={styles.formGroup}>
				<Text style={styles.label}>
					Team ID <Text style={styles.required}>*</Text>
				</Text>
				<TextInput style={styles.input} value={config.teamId} onChangeText={(text) => handleConfigChange("teamId", text)} placeholder="Enter your Team ID" placeholderTextColor="#666" />
			</View>

			<View style={styles.formGroup}>
				<Text style={styles.label}>
					API Key <Text style={styles.required}>*</Text>
				</Text>
				<View style={styles.inputContainer}>
					<TextInput style={[styles.input, styles.passwordInput]} value={config.apiKey} onChangeText={(text) => handleConfigChange("apiKey", text)} placeholder="Enter your API Key" placeholderTextColor="#666" secureTextEntry={!showPassword} />
					<TouchableOpacity style={styles.eyeIcon} onPress={() => setShowPassword(!showPassword)}>
						<Ionicons name={showPassword ? "eye-off-outline" : "eye-outline"} size={20} color="#666" />
					</TouchableOpacity>
				</View>
			</View>

			<View style={styles.formGroup}>
				<Text style={styles.label}>
					Issuer ID <Text style={styles.required}>*</Text>
				</Text>
				<TextInput style={styles.input} value={config.issuerId} onChangeText={(text) => handleConfigChange("issuerId", text)} placeholder="Enter your Issuer ID" placeholderTextColor="#666" />
			</View>

			<View style={styles.formGroup}>
				<Text style={styles.label}>
					Key ID <Text style={styles.required}>*</Text>
				</Text>
				<TextInput style={styles.input} value={config.keyId} onChangeText={(text) => handleConfigChange("keyId", text)} placeholder="Enter your Key ID" placeholderTextColor="#666" />
			</View>

			<View style={styles.formGroup}>
				<Text style={styles.label}>
					Bundle ID <Text style={styles.required}>*</Text>
				</Text>
				<TextInput style={styles.input} value={config.bundleId} onChangeText={(text) => handleConfigChange("bundleId", text)} placeholder="Enter your Bundle ID" placeholderTextColor="#666" />
			</View>

			<TouchableOpacity style={[styles.saveButton, loading && styles.saveButtonDisabled]} onPress={handleSave} disabled={loading}>
				{loading ? <Text style={styles.saveButtonText}>Saving...</Text> : <Text style={styles.saveButtonText}>Save Configuration</Text>}
			</TouchableOpacity>
		</View>
	);
};

const styles = StyleSheet.create({
	container: {
		padding: 20,
	},
	title: {
		fontSize: 18,
		fontWeight: "600",
		color: "#fff",
		marginBottom: 24,
	},
	formGroup: {
		marginBottom: 20,
	},
	label: {
		fontSize: 14,
		color: "#fff",
		marginBottom: 8,
	},
	required: {
		color: "#FF453A",
	},
	input: {
		backgroundColor: "#2A2A2A",
		borderRadius: 8,
		padding: 12,
		color: "#fff",
		fontSize: 14,
	},
	inputContainer: {
		position: "relative",
	},
	passwordInput: {
		paddingRight: 40,
	},
	eyeIcon: {
		position: "absolute",
		right: 12,
		top: "50%",
		transform: [{ translateY: -10 }],
	},
	errorContainer: {
		backgroundColor: "#FF453A15",
		padding: 12,
		borderRadius: 8,
		marginBottom: 16,
	},
	errorText: {
		color: "#FF453A",
		fontSize: 14,
	},
	saveButton: {
		backgroundColor: "#0A84FF",
		borderRadius: 8,
		padding: 12,
		alignItems: "center",
		marginTop: 12,
	},
	saveButtonDisabled: {
		backgroundColor: "#0A84FF50",
	},
	saveButtonText: {
		color: "#fff",
		fontSize: 14,
		fontWeight: "500",
	},
});

export default AppleDeveloperConfig;
